import { computed } from 'vue'

export type HeaderAudience = 'manager' | 'angler'

import type { RouteLocationRaw } from 'vue-router'

export type HeaderLink = {
  labelKey: string
  to?: RouteLocationRaw
  href?: string
  id?: string
}

export interface HeaderConfig {
  audience: HeaderAudience
  links: HeaderLink[]
  ctaLabelKey: string
  ctaRoute: string
  utilityLabelKey: string
  utilityRoute: string
  theme: 'landing' | 'public'
}

const baseConfigs: Record<HeaderAudience, HeaderConfig> = {
  manager: {
    audience: 'manager',
    links: [
      { labelKey: 'sharedHeader.nav.features', id: 'features' },
      { labelKey: 'sharedHeader.nav.pricing', id: 'pricing' },
      { labelKey: 'sharedHeader.nav.testimonials', id: 'testimonials' },
    ],
    ctaLabelKey: 'sharedHeader.cta.manager',
    ctaRoute: '/auth/signup',
    utilityLabelKey: 'sharedHeader.utility.angler',
    utilityRoute: '/pecher',
    theme: 'landing',
  },
  angler: {
    audience: 'angler',
    links: [
      { labelKey: 'sharedHeader.nav.lakes', to: '/lacs' },
      { labelKey: 'sharedHeader.nav.contact', id: 'contact' },
    ],
    ctaLabelKey: 'sharedHeader.cta.angler',
    ctaRoute: '/lacs',
    utilityLabelKey: 'sharedHeader.utility.manager',
    utilityRoute: '/',
    theme: 'public',
  },
}

const toggleAudience = (audience: HeaderAudience): HeaderAudience =>
  audience === 'manager' ? 'angler' : 'manager'

export const useHeaderConfig = (audience: HeaderAudience) => {
  const config = computed(() => baseConfigs[audience])
  const switchLabel = computed(() => baseConfigs[toggleAudience(audience)].utilityLabelKey)
  const switchRoute = computed(() => baseConfigs[toggleAudience(audience)].utilityRoute)

  return {
    config,
    switchLabel,
    switchRoute,
  }
}
